<template>
  <v-layout row justify-center>
    <CModal :show.sync="dialog" :title="dialogTitle" max-width="650px" scrollable id="inquiry-detail-dialog">
        <v-progress-linear v-if="processing" :style="{ margin: 0 }" :indeterminate="true"></v-progress-linear>
        <v-container fill-height fluid :class="$style['card-container']">
          <v-layout nowrap>
            <v-flex>
              <v-card outlined :class="$style['card-content']">
                <v-card-text :class="$style['card-text']">
                  <CRow>
                    <CCol md="5">問い合わせユーザー名</CCol>
                    <CCol md="5">{{ entity.name }}</CCol>
                  </CRow>
                  <CRow>
                    <CCol md="5">問い合わせユーザーメールアドレス</CCol>
                    <CCol md="5">{{ entity.email }}</CCol>
                  </CRow>
                  <CRow>
                    <CCol md="5">問い合わせ日時</CCol>
                    <CCol md="5">{{ entity.created_at }}</CCol>
                  </CRow>
                  <CRow>
                    <CCol md="5">問い合わせ種類</CCol>
                    <CCol md="5">{{ entity.inquiry_type }}</CCol>
                  </CRow>
                  <CRow>
                    <CCol md="5">ステータス</CCol>
                    <CCol md="5">{{ entity.status }}</CCol>
                  </CRow>
                  <CRow>
                    <CCol md="5">お問い合わせ内容</CCol>
                    <CCol md="5" class="inquiry-text">{{ entity.inquiry }}</CCol>
                  </CRow>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      <template #footer>
        <CButton
                :class="$style['reset-dialog-btn']"
                color="primary"
                @click="dialog = false"
        >閉じる</CButton>
      </template>
    </CModal>
  </v-layout>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      resourceName: 'inquiries'
    };
  },
  watch: {
    dialog(show) {
      const vm = this;
      if (show) {
        this.$store.dispatch(`${this.resourceName}/entity/show`, {
          pk: this.$store.getters[this.resourceName + "/entity/pk"]
        });
      }
    },
    isLoading(value) {
      if (value) {
        // ローディングマスクを差し込む
        this.$nextTick(() => {
          const overlayHtml = '<div id="inquiry-detail-dialog-overlay" class="v-overlay v-overlay--absolute v-overlay--active theme--dark" style="z-index: 5;"><div class="v-overlay__scrim" style="opacity: 0.46; background-color: rgb(33, 33, 33); border-color: rgb(33, 33, 33);"></div><div class="v-overlay__content"><div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-circular v-progress-circular--indeterminate" style="height: 64px; width: 64px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="21.333333333333332 21.333333333333332 42.666666666666664 42.666666666666664" style="transform: rotate(0deg);"><circle fill="transparent" cx="42.666666666666664" cy="42.666666666666664" r="20" stroke-width="2.6666666666666665" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg><div class="v-progress-circular__info"></div></div></div></div>';
          const modal = document.getElementById('inquiry-detail-dialog');
          if (modal) {
            const contents = modal.getElementsByClassName('modal-content');
            if (contents.length) {
              contents[0].insertAdjacentHTML('beforebegin', overlayHtml);
            }
          }
        });
      } else {
        const overlay = document.getElementById('inquiry-detail-dialog-overlay');
        if (overlay) {
          overlay.remove();
        }
      }
    }
  },
  computed: {
    entity() {
      return this.$store.getters[`${this.resourceName}/entity/entity`];
    },
    dialog: {
      get() {
        return this.$store.getters[this.resourceName + "/entity/open"];
      },
      set(value) {
        this.$store.commit(this.resourceName + "/entity/close");
      }
    },
    processing() {
      return this.$store.getters[this.resourceName + "/entity/processing"];
    },
    isLoading() {
      return this.$store.getters[this.resourceName + "/entity/isLoading"];
    },
    dialogTitle() {
      return "お問い合わせ詳細";
    }
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<style module lang="scss">
.card-container {
  padding: 0px !important;
  border-bottom: 1px solid #eee;
}
.card-text {
  padding: 10px !important;
}
.card-content {
  overflow-y: auto;
  padding: 8px 0 !important;
  border: none !important;
}
.reset-dialog-btn {
  & > span {
    font-size: 14px !important;
  }
}
</style>
<style scoped lang="scss">
.inquiry-text {
  white-space: pre-wrap;
}
</style>
<style lang="scss">
.v-card__title {
  font-size: 14px !important;
}
</style>
<style lang="scss">
#inquiry-detail-dialog {
  .modal-dialog {
    max-width: 650px !important;
  }
}
</style>
